import { render, staticRenderFns } from "./ProjectConfigurationBackgroundGradients.vue?vue&type=template&id=71830f90&scoped=true&"
import script from "./ProjectConfigurationBackgroundGradients.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationBackgroundGradients.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfigurationBackgroundGradients.vue?vue&type=style&index=0&id=71830f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71830f90",
  null
  
)

export default component.exports